import {Shape} from './shape';

export enum StyleType {
  MODERN = 'modern',
  LEGACY = 'legacy',
}

export interface Style {
  readonly id: string|number;
  readonly serverId?: number;
  readonly lineColor: string;
  readonly bgColor: string;
  readonly shape: Shape;
  readonly styleType?: StyleType
}
